import { PropsWithChildren } from 'react';
import { TableTr } from '@mantine/core';

export type RowValueUnionType = 'PHONE_NUMBER' | 'EMAIL' | 'DEFAULT';

export const TouringCardTableRow: React.FC<PropsWithChildren> = ({
  children,
}) => {
  return <TableTr>{children}</TableTr>;
};
